import { Dialog, ModalDialog } from '@pelckmans/business-components/components/dialog';
import { useContext } from 'react';
import ModalContext from '../../../contexts/ModalContext';
import { useTranslation } from 'react-i18next';
import { ExternalMediaMedialinkGeoGebra } from '../_api/MedialinksApi';
import { Node } from '../_api/TableOfContentsApi';
import MedialinkContentType from '../_components/common/MedialinkContentType';
import MaterialModalHeader from './common/MaterialModalHeader';
import { SupportedUserLanguage } from '@pelckmans/business-components/context/LanguageContext';

type Props = {
  id: string;
  medialink: ExternalMediaMedialinkGeoGebra;
  node: Node;
};

export default function GeoGebraModal({ id, medialink, node }: Props) {
  const { t } = useTranslation();

  const { closeModal } = useContext(ModalContext);

  const { geogebra } = medialink.externalMedia;

  const language: SupportedUserLanguage = geogebra.language === 1 ? 'fr' : 'nl';

  const url = `https://www.geogebra.org/material/iframe/id/${medialink.externalMedia.embedId}/width/${medialink.externalMedia.width}/height/${medialink.externalMedia.height}/border/888888/smb/${geogebra.menuBar}/stb/${geogebra.toolbar}/stbh/${geogebra.toolbarHelp}/ai/${geogebra.inputbar}/asb/${geogebra.stylebar}/sri/${geogebra.resetIcon}/rc/${geogebra.rightClick}/ld/${geogebra.labelDragging}/sdz/${geogebra.shiftDrag}/ctl/false?lang=${language}`;

  return (
    <ModalDialog
      id={id}
      closeTitle={t('ACTIONS.CLOSE')}
      closeViaEscape
      closeOnClickOutside
      onClose={() => closeModal(id)}
      className="material-dialog"
    >
      <MaterialModalHeader
        title={medialink.name}
        description={node.description}
        contentType={<MedialinkContentType medialink={medialink} />}
      />
      <Dialog.Body data-testid="dialog-body">
        <iframe
          role="presentation"
          src={url}
          title={medialink.name}
          allow="fullscreen"
          width={medialink.externalMedia.width}
          height={medialink.externalMedia.height}
          frameBorder="0"
        />
      </Dialog.Body>
    </ModalDialog>
  );
}
